import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DownloadFileService {
    constructor() {}

    /**
     * Downloads a Blob as a file with the specified file name.
     *
     * @param file The Blob to be downloaded.
     * @param fileName The name of the file to be saved as.
     *
     * @returns void
     */
    downloadBlobFile(file: Blob, fileName: string): void {
        const url = URL.createObjectURL(file);
        this.downloadFileFromUrl(url, fileName);
    }

    /**
     * Downloads an image file from a specified URL with the provided file name.
     *
     * @param url - The URL pointing to the image file.
     * @param fileName - The desired file name for the downloaded image.
     *
     * @returns void
     */
    downloadFileFromUrl(url: string, fileName: string): void {
        const linkElem = document.createElement('a');
        linkElem.download = fileName;
        linkElem.href = url;
        linkElem.click();
        linkElem.remove();
    }
}
